import React from 'react'
import PropTypes from 'prop-types'
import {Box, Flex, Text, HStack, Button, useStyleConfig} from '@chakra-ui/react'
import {TextTitleDescription} from '../../text-title-description'
import {ChevronRight} from '../../../icons'
import {remCalc} from '../../../../theme/_utils'
import CustomLink from '../../../custom-link'
import {getGlobalLink} from '../../../../utils/contentstack-utils'
import {useGetCategoriesData} from '../../../../custom-api/hooks/use-get-categories-data'
import useDamImage from '../../../../custom-hooks/use-dam-image'
import {useProducts} from '@salesforce/commerce-sdk-react'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const PromoSlideImageCard = ({title, bodyCopy, button, url, alt, images}) => {
    const styles = useStyleConfig('PromoSlider')
    const categoriesData = useGetCategoriesData()
    const {locale} = useMultiSite()
    const {data: productsData} = useProducts(
        {
            parameters: {
                ids: button?.productsfcc?.data?.length > 0 ? button.productsfcc.data[0].id : '',
                expand: ['availability', 'images'],
            },
            headers: {
                'x-debug': 'promo-slide-img-index',
            },
        },
        {
            enabled: button?.productsfcc?.data?.length > 0,
        },
    )
    const {
        url: ctaUrl,
        label: ctaLabel,
        isAbsolute,
    } = getGlobalLink({
        link: button,
        categoriesData,
        productsData,
        locale: locale?.alias || locale?.id?.toLowerCase(),
    })

    const {url: imageUrl, ratio} = useDamImage(images)
    // const handleRedirect = (e) => {
    //     e.preventDefault()
    //     if (cta && cta?.href) {
    //         isExternalUrl ? window.open(cta.href, '_blank') : navigate(cta.href)
    //     }
    // }

    const imageToDisplay = imageUrl || url

    return (
        <CustomLink isExternal={isAbsolute} href={ctaUrl} data-testid="promo-slide-image-card-link">
            <Box
                {...styles.promoSlideImageContainer}
                data-testid={`swiper-slide-image-${title || 'container'}`}
            >
                <Flex
                    __css={{...styles.promoSlideBackground, ...styles.promoSlideBackgroundImage}}
                    backgroundImage={imageToDisplay ? `url(${imageToDisplay})` : 'none'}
                    aria-label={alt || 'background image description'}
                    aspectRatio={{lg: ratio}}
                >
                    <Flex sx={styles.promoSliderContent}>
                        <TextTitleDescription title={title} {...styles.textTitleDescriptionImage}>
                            {bodyCopy}
                        </TextTitleDescription>
                        {ctaLabel && (
                            <Button variant="inverse" aria-label={ctaLabel} tabIndex={0}>
                                <HStack gap={remCalc(10)}>
                                    <Text as="span" {...styles.promoSlideCardTextImage}>
                                        {ctaLabel}
                                    </Text>
                                    <ChevronRight
                                        aria-label="right icon"
                                        {...styles.imageCardChevronIcon}
                                    />
                                </HStack>
                            </Button>
                        )}
                    </Flex>
                </Flex>
            </Box>
        </CustomLink>
    )
}

PromoSlideImageCard.propTypes = {
    title: PropTypes.string,
    bodyCopy: PropTypes.string,
    button: PropTypes.object,
    url: PropTypes.string,
    alt: PropTypes.string,
    images: PropTypes.object,
    isExternalUrl: PropTypes.bool,
}

export default PromoSlideImageCard
